// js/js_psych_manager.js
import { initJsPsych } from 'jspsych';
import { addID } from '../../vendor/stroop/plugins/poldrack_utils';

export default class JsPsychManager {
  constructor(config = {}) {
    this.jsPsych = initJsPsych({
      on_trial_finish: (data) => {
        this.onTrialFinish(data);

        if (typeof config.on_trial_finish === 'function') {
          config.on_trial_finish(data);
        }
      },
      ...config
    });
  }

  onTrialFinish(data) {
    // Tu peux personnaliser ce comportement
    addID('stroop', this.jsPsych);
  }

  getInstance() {
    return this.jsPsych;
  }
}
